(function () {
    'use strict';
    realmCommerceApp.directive("addToCartButton", AddToCartButton);

    /*@ngInject*/
    function AddToCartButton(cartService, errorsService, $uibModal, $window) {
        var directive = {
            restrict: 'EC',
            link: link
        }
        return directive;

        function link(scope, element, attrs) {
            scope.addToCart = addToCart;
            scope.inCart = inCart;
            inCart();

            element.bind("click", function (e) {
                addToCart();
            });

            function addToCart() {
                var html = element.html();
                element.addClass('adding');
                element.text("Adding");
                cartService.addItem(attrs.productId, attrs.quantity).then(function (data) {
                    element.removeClass('adding').addClass('success').text("Added").unbind("click");
                    promptCheckout(attrs.productId, data.message);
                }).catch(function(exception) {
                    element.removeClass('adding').html(html);
                    errorsService.errorCallback(exception);
                });
            }

            function inCart() {
                let cartPreview = cartService.getCartPreview();
                if(cartPreview.itemCount > 0) {
                    cartPreview.items.forEach(function (item) {
                        if (item.product.entity_id === attrs.productId) {
                            element.addClass('success').text("Added").unbind("click");
                        }
                    });
                }
            }

            function promptCheckout(productId, message) {
                const product = cartService.getCart().items.find( item => item.product.entity_id == productId );
                const productImageUrl = product.product.imageurl;
                const modalInstance =  $uibModal.open({
                    template: require('../layout/modal/promptCheckout.modal.html'),
                    controller: 'MessagesModalController',
                    controllerAs: 'vm',
                    bindToController: true,
                    resolve: {
                        messageHtml: () => `<img src="${productImageUrl }" class="img-responsive" />`,
                        messageSubject: () => 'Item was added to your cart <span class="fa fa-check-square"></span>'
                    }
                });

                return modalInstance.result
                                    .then(() => $window.location.href = '/cart')
                                    .catch(() => {});
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./static/js/app/components/addtocart.directive.js